__turbopack_context__.v({
  "freeBox": "PlasmicDescription-module__RczWQa__freeBox",
  "root": "PlasmicDescription-module__RczWQa__root",
});
